export default "__VITE_ASSET__BPv4vR09__"